<div class="publisher-logo-container" [style]="{ backgroundColor: publisher.style?.bannerBgColor || '#000000' }">
  <img class="publisher-logo"
    [alt]="publisher.org"
    [title]="publisher.org"
    [src]="publisher.banner_image || publisher.profile_image"
  />  
</div>